/**
 * Space measures come from facts computed nightly; the stamp says how
 * fresh they are so nobody reads this morning's bookings into yesterday's
 * number. Null when the source is live.
 */
export const factsAsOfLabel = (iso: string | null): string | null => {
  if (!iso) {
    return null;
  }
  const at = new Date(iso);
  if (Number.isNaN(at.getTime())) {
    return null;
  }
  const ageHours = (Date.now() - at.getTime()) / 3_600_000;
  const when = at.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit"
  });
  if (ageHours > 36) {
    return `Facts last computed ${when} — older than usual`;
  }
  return `Facts computed ${when}, refreshed nightly`;
};
